// extracted by mini-css-extract-plugin
export default {"result":"LoadingComponent_result__2d51t","image":"LoadingComponent_image__wyBa0"};